import { useMemo, useRef, useState, useEffect } from 'react'
import Vimeo from '@vimeo/player'

/**
 * Embed options https://github.com/vimeo/player.js/
 */

const useVimeo = settings => {
  const $el = useRef()
  const player = useRef()
  const [loaded, setLoaded] = useState(false)
  const [aspectRatio, setAspectRatio] = useState(1.7777777778)
  const [bufferstart, setBufferstart] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [play, setPlay] = useState(false)
  const options = useMemo(
    () => ({
      id: '148751763',
      ...settings,
    }),
    [settings]
  )

  useEffect(() => {
    player.current = new Vimeo($el.current, options)

    player.current.on('loaded', () => setLoaded(true))
    player.current.on('bufferstart', () => setBufferstart(true))
    player.current.on('bufferend', () => setBufferstart(false))
    player.current.on('play', () => setPlay(true))
    player.current.on('playing', () => setPlaying(true))
    player.current.on('pause', () => setPlaying(false))
    player.current.on('ended', () => setPlaying(false))

    return () => {
      player.current.off('loaded')
      player.current.off('bufferstart')
      player.current.off('bufferend')
      player.current.off('play')
      player.current.off('playing')
      player.current.off('pause')
      player.current.off('ended')
    }
  }, [options])

  return {
    $el,
    aspectRatio,
    bufferstart,
    loaded,
    play,
    playing,
    player: player.current,
  }
}

export default useVimeo
